import api from './api';
import {fetchUserCarts, fetchUserProfile} from './user';
import {claimCartOwnership, cleanupCartOwnership, getCart, mergeCarts, setCart} from './cart';
import {analyticsSignUp} from '../middlewares/analytics/actions';

export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';

const initialState = {token: undefined};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case AUTH_SET_TOKEN:
      return {
        ...state,
        token: payload
      };
    case AUTH_LOG_OUT:
      return {
        ...state,
        token: undefined
      };
    default:
      return state;
  }
}

export function authorizeToken(token) {
  return (dispatch, getState) => Promise.resolve(dispatch({type: AUTH_SET_TOKEN, payload: token}))
    .then(() => dispatch(fetchUserProfile()))
    .catch(err => {
      dispatch({type: AUTH_SET_TOKEN, payload: undefined});
      throw err;
    })
    .then(() => dispatch(fetchUserCarts()))
    .then(cartResponse => {
      const anonymousCart = getState().cart;
      const authorizedCarts = cartResponse.content.items;

      const specialOrderCart = [anonymousCart].concat(authorizedCarts)
        .filter(cart => !!cart)
        .find(cart => cart.specialService || (cart.items && cart.items.some(cartItem => !!cartItem.specialService)));

      if (specialOrderCart) {
        return specialOrderCart.anonymous
          ? dispatch(claimCartOwnership(specialOrderCart.id, specialOrderCart.tokenValue))
          : {content: specialOrderCart};
      }

      if (anonymousCart && authorizedCarts.length) {
        return dispatch(mergeCarts(...authorizedCarts, anonymousCart));
      }

      if (anonymousCart) {
        return dispatch(claimCartOwnership(anonymousCart.id, anonymousCart.tokenValue));
      }

      if (authorizedCarts.length > 1) {
        return dispatch(mergeCarts(...authorizedCarts));
      }

      if (authorizedCarts.length) {
        return {content: authorizedCarts[0]};
      }
    })
    .then(cartDescriptor => cartDescriptor && dispatch(getCart(cartDescriptor.content.id, cartDescriptor.content.tokenValue)));
}

export function deAuthorizeToken(token) {
  return (dispatch, getState) => {
    const {cart} = getState();

    return (
      cart
        ? dispatch(cleanupCartOwnership(cart.id)).then(cleanupResponse => dispatch(setCart(cleanupResponse.content)))
        : Promise.resolve()
    )
      .then(() => dispatch(api.delete(`users/api-tokens/${token}`)))
      .then(() => dispatch({type: AUTH_LOG_OUT}));
  }
}

export function logInWithCredentials(login, password) {
  return dispatch => dispatch(api.post('users/api-tokens', {login, password}))
    .then(loginResponse => dispatch(authorizeToken(loginResponse.content.token)));
}

export function signUpWithCredentials(email, password, tosAccepted, newsletterSubscribed) {
  return dispatch => dispatch(api.post('users/', {
    email,
    user: {plainPassword: password},
    tosAccepted: tosAccepted ? 1 : undefined,
    newsletterSubscribed: newsletterSubscribed ? 1 : undefined
  }))
    .then(response => {
      dispatch(analyticsSignUp(email));

      return response;
    });
}

export function initiateEmailVerification(email) {
  return dispatch => dispatch(api.post('users/email-verification-request', {email}));
}

export function completeEmailVerification(userId, token) {
  return dispatch => dispatch(api.post('users/email-verification', {userId, token}))
    .then(loginResponse => dispatch(authorizeToken(loginResponse.content.token)));
}

export function initiateOAuth(service, returnUrl) {
  return dispatch => dispatch(api.post('users/oauth', {service, returnUrl}));
}

export function completeOAuth(serviceToken) {
  return dispatch => dispatch(api.post(`users/oauth/${serviceToken}`))
    .then(oAuthResponse => {
      if (oAuthResponse.content.request.successful) {
        return dispatch(authorizeToken(oAuthResponse.content.token));
      }

      throw oAuthResponse.content.request;
    });
}

export function completeEmailOAuth(serviceToken, email) {
  return dispatch => dispatch(api.post(`users/oauth-with-email/${serviceToken}`, {email}))
    .then(oAuthResponse => dispatch(authorizeToken(oAuthResponse.content.token)));
}

export function initiatePasswordRecovery(email) {
  return dispatch => dispatch(api.post('users/password-reset-request', {email}));
}

export function completePasswordRecovery(userId, token, newPassword) {
  return dispatch => dispatch(api.post('users/password-reset', {
    userId,
    token,
    user: {plainPassword: newPassword}
  }))
    .then(recoveryResponse => dispatch(authorizeToken(recoveryResponse.content.token)));
}



// WEBPACK FOOTER //
// ./ducks/auth.js